import React, { FunctionComponent } from 'react';
import { cn } from '@companion-professional/webutils';
import { Heading, Text } from '@companion-professional/components';

interface LoginHeadingProps {
  // title is the larger text in the heading.
  title: string;

  // children: what's displayed below the title.
  children?: React.ReactNode;
}

export const LoginHeading: FunctionComponent<LoginHeadingProps> = ({ title, children }) => {
  return (
    <>
      <Heading level="page" as="h3" className={cn({ 'mb-1': children, 'mb-6': !children })}>
        {title}
      </Heading>
      {children ? (
        <Text tone="muted" className="mb-4">
          {children}
        </Text>
      ) : null}
    </>
  );
};
